import { isNode } from 'anodum';
import { DEFAULT_BLOCK_TAG } from '../constants/editable-elements';

const wrapIntoElement = (element, selector = DEFAULT_BLOCK_TAG, shouldReplace = false) => {
  if (!selector) {
    console.error(`${selector} is not a valid tag value`);
    return null;
  }

  if (!isNode(element)) {
    console.error(`${element} is not a node`);
    return null;
  }
  const { ownerDocument: liveDocument, parentNode } = element;

  if (shouldReplace && !parentNode) {
    console.error(`${element} has not parentNode`);
    return null;
  }

  const newElement = liveDocument.createElement(selector);
  if (shouldReplace) {
    parentNode.replaceChild(newElement, element);
  }
  newElement.append(element);

  return newElement;
};

export default wrapIntoElement;
